import React from "react";
import { Field, reduxForm } from "redux-form";

import { Button, Grid, Stack } from "@braintrust/braintrust-ui-components";
import { Form } from "@js/forms/components/form";
import { TextField } from "@js/forms/fields";

const VERIFY_STRIPE_ACH_FORM_ID = "verify-stripe-ach-payment-method";

export type VerifyStripeACHFormData = {
  amount_1: string;
  amount_2: string;
};

export type VerifyStripeACHFormDataWithDescriptorCode = {
  descriptor_code: string;
};

type VerifyStripeACHFormProps = {
  onCancel: () => void;
};

export const VerifyStripeACHForm = reduxForm<
  VerifyStripeACHFormData,
  VerifyStripeACHFormProps
>({
  form: VERIFY_STRIPE_ACH_FORM_ID,
  enableReinitialize: true,
  initialValues: {
    amount_1: "0",
    amount_2: "0",
  },
})(({ submit, error, submitting, onCancel }) => (
  <Form onSubmit={submitting ? null : submit} error={error}>
    <Grid container spacing={4}>
      <Grid
        size={{
          xs: 6,
        }}
      >
        <Field
          variant="standard"
          id="amount_1"
          name="amount_1"
          component={TextField}
          label="Amount 1"
          size="small"
          slotProps={{
            input: {
              startAdornment: "$",
            },
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 6,
        }}
      >
        <Field
          variant="standard"
          id="amount_2"
          name="amount_2"
          component={TextField}
          label="Amount 2"
          size="small"
          slotProps={{
            input: {
              startAdornment: "$",
            },
          }}
        />
      </Grid>
    </Grid>
    <Grid className="buttons right mt+">
      <Button variant="primary" onClick={onCancel}>
        Cancel
      </Button>
      <Button variant="primary" disabled={submitting} type="submit">
        Verify
      </Button>
    </Grid>
  </Form>
));

export const VerifyStripeACHFormWithDescriptorCode = reduxForm<
  VerifyStripeACHFormDataWithDescriptorCode,
  VerifyStripeACHFormProps
>({
  form: VERIFY_STRIPE_ACH_FORM_ID,
  enableReinitialize: true,
  initialValues: {
    descriptor_code: "",
  },
})(({ submit, error, submitting, onCancel }) => (
  <Form onSubmit={submitting ? null : submit} error={error}>
    <Field
      variant="standard"
      id="descriptor_code"
      name="descriptor_code"
      component={TextField}
      label="Code"
      size="small"
      sx={{ maxWidth: "200px", mt: 2, mb: 3 }}
    />
    <Stack direction="row" sx={{ gap: 1, justifyContent: "end" }}>
      <Button variant="primary" onClick={onCancel}>
        Cancel
      </Button>
      <Button variant="primary" disabled={submitting} type="submit">
        Verify
      </Button>
    </Stack>
  </Form>
));
